import {
  BusinessType,
  type SupportedBusinessTypeItem
} from "@kivunova/kivufrontendcommon";

export const getRegistrationPlatformConfigState = (
  businessTypes: SupportedBusinessTypeItem[] | undefined | null,
  loadError = false
) => {
  const registryLoaded = (businessTypes?.length ?? 0) > 0 || loadError;

  return {
    registryLoaded,
    isPlatformConfigLoading: !registryLoaded
  };
};

/** Enabled business types from `supportedBusinessTypes` GraphQL (stage flags). */
export const getRegistrationBusinessTypeOptions = (
  businessTypes: SupportedBusinessTypeItem[] | undefined | null,
  registryLoaded = false
): BusinessType[] => {
  const enabled =
    businessTypes?.filter((item) => item.enabled).map((item) => item.key) ?? [];

  if (enabled.length > 0) {
    return enabled;
  }

  if (registryLoaded) {
    return [BusinessType.RETAIL];
  }

  return [];
};

export const getRegistrationBusinessTypeValues = (
  businessTypes: SupportedBusinessTypeItem[] | undefined | null,
  registryLoaded = false
): string[] =>
  getRegistrationBusinessTypeOptions(businessTypes, registryLoaded).map(
    (value) => String(value)
  );
